export default __webpack_public_path__ + "static/media/mos-logo-word-white.1f7bb838.svg";